var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-50 md-large-size-100"},[_c('SearchTable',{ref:"materialsTable",attrs:{"header":{
        title: 'Magacin',
        icon: 'inventory_2',
        class: 'md-card-header-brand',
      },"queriedData":_vm.materials,"metaData":_vm.materialsMetaData,"getItems":_vm.getMaterialCount,"openItem":_vm.openMaterial,"params":_vm.materialParams,"sortBy":'type'}},[_c('div',{staticClass:"md-layout-item reset-inventory-container",attrs:{"slot":"header"},slot:"header"},[_c('ResetInventoryButton',{attrs:{"onReset":_vm.getMaterialCount}})],1)])],1),_c('div',{staticClass:"md-layout-item md-size-30 md-large-size-100"},[(_vm.openedMaterial)?_c('SearchTable',{ref:"inputsTable",attrs:{"header":{
        title: _vm.openedMaterialTitle,
        icon: 'inventory_2',
        class: 'md-card-header-brand',
      },"queriedData":_vm.inputs,"metaData":_vm.inputsMetaData,"getItems":_vm.getManualMaterialInputs,"newItem":_vm.addMaterial,"params":_vm.inputsParams,"forEachSelected":[
        {
          icon: 'delete',
          label: 'Briši',
          class: 'md-danger',
          function: _vm.deleteExpenses,
        } ],"sortBy":'created'}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }